import GettingStartedPage from './GettingStartedPage';

export default GettingStartedPage;
